import type { SVGProps } from 'react';

const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M19 13.5 30.6 0h-2.8l-10 11.8L9.7 0H.3l12.2 17.8L.3 32h2.8l10.7-12.4L22.3 32h9.3zm-3.8 4.4L14 16.2 4.1 2.1h4.2l8 11.4 1.2 1.8L27.9 30h-4.2z"
    />
  </svg>
);

export default SvgTwitter;
